import React from "react"
import Layout from "../modules/Layout"
import BodyBlocks from "../technical/BodyBlocks"
import Breadcrumbs from "../modules/Breadcrumbs"

import * as moment from "moment"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"
import Richtext from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Richtext"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"
import Pagination from "../modules/Pagination"
import CategoryTabs from "../molecules/CategoryTabs"

import Seo from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Seo"

import { useTranslation } from "react-i18next"
import NewsHeader from "../blocks/NewsHeader"
import {
  IbmWatsonKnowledgeCatalog16,
  NotebookReference16,
  Tools16,
} from "@carbon/icons-react"
import TextOnImageBlock from "../blocks/TextOnImageBlock"

const NewsOverviewPage = ({
  full_slug,
  content,
  news,
  language,
  numPages,
  currentPage,
  breadcrumbs,
  name,
}) => {
  const { t, i18n } = useTranslation()
  let seoImage = null

  if (
    !content.image?.filename &&
    content.body &&
    content.body[0] &&
    content.body[0].image &&
    content.body[0].image.filename
  ) {
    seoImage = content.body[0].image.filename
  } else {
    seoImage = content.image?.filename
  }

  let preparedNews = news.map((n) => {
    return Object.assign({}, n, { content: JSON.parse(n.content) })
  })

  preparedNews = preparedNews.map((n) => {
    if (
      !n.content.image.filename &&
      n.content.body &&
      n.content.body[0] &&
      n.content.body[0].image &&
      n.content.body[0].image.filename
    ) {
      n.content.image = n.content.body[0].image
    }
    if (!n.content.image.filename) {
      n.content.image = { filename: process.env.GATSBY_IMG_PLACEHOLDER }
    }

    return n
  })

  let pagePath = full_slug

  if (pagePath[pagePath.length - 1] === "/") {
    pagePath = pagePath.slice(0, pagePath.length - 1)
  }

  const nextPage = `${pagePath}/${String(currentPage + 1)}`
  const prevPage =
    currentPage - 1 === 1
      ? `${pagePath}`
      : `${pagePath}/${String(currentPage - 1)}`

  const bodySplitIndex =
    content?.body?.findIndex(
      (block) => block.component === "news_listing_placeholder_block"
    ) || null

  let topBody = []
  let bottomBody = content.body

  if (bodySplitIndex) {
    topBody = content.body.slice(0, bodySplitIndex)
    bottomBody = content.body.slice(bodySplitIndex + 1)
  }

  let newsCategory = t("generic.news_category_name")

  return (
    <Layout language={language}>
      <Seo
        title={content.headline}
        content={content}
        og_image={seoImage}
        name={name}
      />
      {topBody && topBody.length > 0 ? (
        <>
          {topBody[0]?.component !== "hero_block" && (
            <Breadcrumbs breadcrumbs={breadcrumbs}></Breadcrumbs>
          )}
          {topBody?.length > 0 && topBody[0]?.component !== "hero_block" && (
            <NewsHeader
              block={{
                kicker: content.kicker,
                headline: content.headline,
                image: content.image,
                show_square: content.show_square,
              }}
              breadcrumbs={breadcrumbs}
            />
          )}
          <BodyBlocks body={topBody} breadcrumbs={breadcrumbs} />
        </>
      ) : (
        <NewsHeader
          block={{
            kicker: content.kicker,
            headline: content.headline,
            image: content.image,
            show_square: content.show_square,
          }}
          breadcrumbs={breadcrumbs}
        />
      )}
      <CategoryTabs />
      <section className="">
        <div className="block-w-container">
          <div className="flex flex-row flex-wrap -mx-grid">
            {preparedNews.length > 0 &&
              preparedNews.map((item) => (
                <div
                  className="w-full mb-10 px-grid md:w-1/2 lg:w-1/3"
                  key={item.full_slug}
                >
                  <Link
                    className="block h-full transition-shadow duration-500 bg-gray-50 group hover:shadow-lg"
                    link={item.fields.full_slug_prepared}
                  >
                    <div className="block w-full aspect-auto">
                      <Image
                        className="object-cover w-full aspect-[4/3] h-auto"
                        image={item.content.image}
                      />
                    </div>
                    <div className="flex-1 p-4">
                      <div>
                        <div className="mb-4 font-bold text-primary">
                          {item.content.categories?.length > 0 && (
                            <>
                              {item.content.categories[0].slug === "news" && (
                                <NotebookReference16 className="inline-block -mt-0.5" />
                              )}
                              {item.content.categories[0].slug === "how-to" && (
                                <Tools16 className="inline-block  -mt-0.5" />
                              )}
                              {item.content.categories[0].slug ===
                                "know-how" && (
                                <IbmWatsonKnowledgeCatalog16 className="inline-block  -mt-0.5" />
                              )}
                              <span className="ml-2 tracking-widest prose-sm uppercase hyphens-auto ">
                                {item.content.categories[0].name}
                              </span>
                            </>
                          )}
                          {item.content.categories?.length > 0 &&
                            item.content.categories[0].name === newsCategory &&
                            item.content.display_date?.length > 0 && (
                              <>
                                <span className="ml-2 mr-2">-</span>
                                <span className="prose-sm ">
                                  {moment(item.content.display_date).format(
                                    "DD.MM.YYYY"
                                  )}
                                </span>
                              </>
                            )}
                        </div>
                        <span className="block h-12 font-bold transition-transform duration-500 origin-left transform line-clamp-2 group-hover:scale-102">
                          {item.content.title}
                        </span>
                        <Richtext
                          className="mt-4 prose-sm line-clamp-6"
                          text={item.content.teaser}
                        />
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
          </div>
        </div>
      </section>
      <Pagination
        currentPage={currentPage}
        isFirstPage={currentPage === 1}
        isLastPage={currentPage === numPages}
        totalPages={numPages}
        pagePath={pagePath}
        nextPage={nextPage}
        prevPage={prevPage}
      />
      {bottomBody && bottomBody.length > 0 && <BodyBlocks body={bottomBody} />}
    </Layout>
  )
}

export default NewsOverviewPage
